<template>
  <aside :class="market === true ? '' : 'aside-filters' ">
    <button
      @click="toggleFilters()"
      class="btn btn--with-icon btn--inverted hidden-desktop open-filter"
    >
      <vs-icon icon="filter_list" />
      Filtrar
    </button>

    <!-- If we are in market, makeCollapsable is true and we insert the collapsable button into the DOM -->
    <div v-if="collapsableFilters.makeCollapsable">
      <button
        @click="collapsableFilters.showFilters = !collapsableFilters.showFilters"
        class="btn btn--with-icon btn--inverted hidden-mobile open-filter"
        style="width:100%"
      >
        <vs-icon icon="filter_list" />
        Filtrar
      </button>
    </div>

     <!-- Filters show or hide depending on collapsibleFilters.showFilters  -->
     <!-- We also add top margin when filters are shown -->
    <div class="offer-filters"  :class="{ expanded: expanded, 'hidden-desktop':!collapsableFilters.showFilters, 'top-margin':!expanded && collapsableFilters.makeCollapsable, 'transition':collapsableFilters.makeCollapsable}">
      <div class="hidden-desktop">
        <button @click="toggleFilters()" class="close-filters">
          <vs-icon icon="keyboard_backspace" />
        </button>
        <h2>Filtrar por</h2>
      </div>
      <section>
        <h3>Tipo de oferta</h3>
        <div class="input-group" v-if="filterSubtype">
          <select
            name="filters-subtype"
            :class="{ changed: !!filters.subtype }"
            v-model="filters.subtype"
            @change="inputChanged()"
          >
            <option
              :key="index"
              :value="subtype.value"
              :text="subtype.name"
              v-for="(subtype, index) in offerSubtypes"
            >
              {{ subtype.name }}
            </option>
          </select>
          <label for="filters-subtype">Tipo de oferta</label>
        </div>
        <div class="input-group">
          <select
            name="filters-type"
            :class="{ changed: !!filters.type }"
            v-model="filters.type"
            @change="inputChanged()"
          >
            <option
              :key="index"
              :value="type.value"
              :text="type.name"
              v-for="(type, index) in offerTypes"
            >
              {{ type.name }}
            </option>
          </select>
          <label for="filters-type">Compra y venta</label>
        </div>
      </section>

      <section v-if="filterByState">
        <h3>Estado de oferta</h3>
        <div class="input-group">
          <select
            name="filters-states"
            :class="{ changed: !!filters.states }"
            v-model="states"
            @change="inputChanged()"
          >
            <option
              :key="index"
              :value="state.value"
              :text="state.name"
              v-for="(state, index) in offerStates"
            >
              {{ state.name }}
            </option>
          </select>
          <label for="filters-subtype">Estados</label>
        </div>
      </section>

      <section>
        <h3>Semana de entrega</h3>
        <WeWeekPicker
          data-test="startoffer"
          class="small"
          label="Semana de oferta desde"
          v-model="weekFrom"
          ref="weekStartAtSelector"
          @input="inputChanged()"
        />
        <WeWeekPicker
          data-test="endoffer"
          class="small"
          label="Semana de oferta hasta"
          v-model="weekTo"
          ref="weekEndAtSelector"
          :min-week="weekFrom"
          @input="inputChanged()"
        />
      </section>

      <section v-if="currentUser.admin">
        <h3>Pago Seguro</h3>
        <div class="checkbox">
          <div class="wrapper">
            <input
              type="checkbox"
              @change="inputChanged()"
              id="securePaymentFilter"
              class="we-check"
              v-model="securePaymentFilter"
            />
            <label data-test="input-checkbox" for="securePaymentFilter"
              >Filtrar pago seguro</label
            >
          </div>
        </div>
        <div v-show="securePaymentFilter" class="input-group secure-payment">
          <select
            name="securePaymentStageSelector"
            v-model="securePaymentStage"
            :class="{ changed: !!securePaymentStage }"
            @change="inputChanged()"
          >
            <option value="">Estado</option>
            <option
              :key="index"
              :value="item"
              :text="item"
              v-for="(item, index) in securePaymentStages"
            >
              {{ $t(`securePayment.${item}`) }}
            </option>
          </select>
          <label for="securePaymentStageSelector">Estado</label>
        </div>
      </section>

      <section>
        <h3>Empresa</h3>
        <div class="input-group">
          <select
            name="orgFilter"
            v-model="filters.organizationId"
            @change="inputChanged()"
          >
            <option value="">Empresa</option>
            <option
              :key="index"
              :value="item.id"
              :text="item.businessName"
              v-for="(item, index) in organizationList"
            >
              {{ item.businessName }} (#{{ item.id }})
            </option>
          </select>
          <label for="orgFilter">Empresa</label>
        </div>
      </section>

      <section>
        <h3>Establecimiento</h3>
        <div class="input-group">
          <!-- <span v-if="establishmentId" class="search-select">Establecimiento</span> -->
          <model-select
            :options="establishmentsOptions"
            v-model="filters.counterpartId"
            @input="inputChanged()"
            placeholder="Establecimiento"
          >
          </model-select>
        </div>
      </section>

      <section class="offer-filters__buttons">
        <button
          @click="clearFilters"
          class="btn btn-secondary btn-flat btn--full-width"
        >
          Limpiar filtros
        </button>
        <button
          @click="inputChanged('apply')"
          class="btn hidden-desktop btn--full-width"
        >
          Aplicar filtros
        </button>
      </section>
    </div>
  </aside>
</template>

<script>
import WeWeekPicker from "../lib/WebExperto/components/WeWeekPicker.vue";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import { mapState } from "vuex";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";

const SelectableAttributes = gql`
  query retrieveSelectableAttributes($object: String!, $attribute: String!) {
    retrieveSelectableAttributes(object: $object, attribute: $attribute) {
      code
      selectableAttributes
      message
      success
    }
  }
`;

const retrieveParentAttributes = gql`
  query retrieveParentAttributes(
    $object: String!
    $attribute: String!
    $parentObject: String!
    $parentAttribute: String!
    $scope: String
  ) {
    retrieveParentAttributes(
      object: $object
      attribute: $attribute
      parentObject: $parentObject
      parentAttribute: $parentAttribute
      scope: $scope
    ) {
      success
      parentAttributes {
        businessName
        id
      }
    }
  }
`;

const retrieveFamilyAttributes = gql`
  query retrieveFamilyAttributes(
    $currentUserToken: String!
    $familyAttributes: FamilyAttributesInput!
  ) {
    retrieveFamilyAttributes(
      currentUserToken: $currentUserToken
      familyAttributes: $familyAttributes
    ) {
      id
      name
      organizationId
    }
  }
`;

const filters = {
  all: {
    name: "Todos los estados",
    value: [
      "finished",
      "cancelled",
      "deserted",
      "expired",
      "published",
      "accept_pending",
      "in_negotiation",
      "pending",
    ],
  },
  actives: {
    name: "Todos los estados",
    value: ["pending", "in_negotiation", "published", "accept_pending"],
  },
  inactives: {
    name: "Todos los estados",
    value: ["finished", "expired", "cancelled"],
  },
  allNegotiations: {
    name: "Todos los estados",
    value: ["in_negotiation", "published", "accept_pending"],
  },
  pending: { name: "Pendiente de publicación", value: ["pending"] },
  inNegotiation: { name: "En negociación", value: ["in_negotiation"] },
  published: { name: "Publicada", value: ["published"] },
  waitingResponse: {
    name: "Esperando respuesta",
    value: ["waiting_response", "accept_pending"],
  },
  responsePending: {
    name: "Pendiente de respuesta",
    value: ["response_pending", "accept_pending"],
  },
  expired: { name: "Vencidas", value: ["expired"] },
  finished: { name: "Finalizadas", value: ["finished"] },
  cancelled: { name: "Canceladas", value: ["cancelled"] },
};

const filterGroup = {
  adminOffers: [
    filters.all,
    filters.pending,
    filters.inNegotiation,
    filters.published,
    filters.waitingResponse,
    filters.responsePending,
    filters.finished,
    filters.cancelled,
    filters.expired,
  ],
  activeOffers: [
    filters.actives,
    filters.pending,
    filters.inNegotiation,
    filters.published,
    filters.waitingResponse,
    filters.responsePending,
  ],
  finishedOffers: [
    filters.inactives,
    filters.finished,
    filters.cancelled,
    filters.expired,
  ],
  activeNegotiations: [
    filters.allNegotiations,
    filters.responsePending,
    filters.waitingResponse,
  ],
  finishedNegotiations: [
    filters.inactives,
    filters.finished,
    filters.cancelled,
    filters.expired,
  ],
};

export default {
  name: "offers-filters",
  components: {
    WeWeekPicker,
    ModelSelect,
  },
  props: {
    filterByState: {
      type: Boolean,
      required: false,
      default: true,
    },
    filterType: {
      type: String,
      required: true,
    },
    filterSubtype: {
      type: Boolean,
      required: false,
      default: true,
    },
    market: {
      type: Boolean,
      required: false,
    },
    userCanSell: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      cleaning: false,
      filters: {},
      states: filterGroup[this.filterType][0].value,
      weekFrom: null,
      weekTo: null,
      loadingSelectableAtt: false,
      loadingRetrieveParent: false,
      loadingRetrieveFamily: false,
      offerTypes: [
        { name: "Venta", value: "sell" },
        { name: "Compra", value: "buy" },
        { name: "Compra y venta", value: undefined },
      ],
      offerSubtypes: [
        { name: "Directa", value: "direct" },
        { name: "Abierta", value: "open" },
        { name: "Muvin", value: "muvin" },
        { name: "Tipo de oferta", value: undefined },
      ],
      expanded: false,
      securePaymentFilter: false,
      securePaymentStage: "",
      securePaymentStages: [],
      organizationList: [],
      establishmentId: "",
      establishmentsList: [],
      collapsableFilters: {
        showFilters:true,
        makeCollapsable:false,
      }
    };
  },
  created() {
    if (this.market) {
        this.collapsableFilters = {
        showFilters:false,
        makeCollapsable:true,
      }
      if (this.userCanSell) {
        this.filters.type = "buy";
      } else {
        this.filters.type = "sell";
      }
      this.inputChanged("");
    }
    if (this.currentUser.admin) {
      this.getSecurePaymentLapseList();
    }
    this.getBusinessList();
    this.getEstablishmentsList();

    window.addEventListener("scroll", this.scrollHandler);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollHandler);
  },
  mounted() {
    let filters = document.querySelector(".aside-filters");
    if(filters) {
      if (filters.scrollHeight > window.innerHeight) {
      filters.classList.add("static");
    }
    }
  },
  computed: {
    offerStates() {
      return filterGroup[this.filterType];
    },
    ...mapState({
      currentUser: (state) => state.User.currentUser,
    }),
    establishmentsOptions() {
      if (this.filters.organizationId) {
        return this.establishmentsList
          .filter((est) => est.organizationId == this.filters.organizationId)
          .map((arr) => {
            return { value: arr.id, text: arr.name };
          });
      } else {
        return this.establishmentsList.map((arr) => {
          return { value: arr.id, text: arr.name };
        });
      }
    },
  },
  watch: {
    "filters.price": function (newVal, oldVal) {
      if (newVal === "") {
        delete this.filters.price;
      }
    },
    securePaymentFilter() {
      if (!this.securePaymentFilter) {
        this.filters.securePayment = null;
      }
    },
    weekFrom() {
      if (this.weekTo) {
        if (this.weekFrom.split("-")[1] === this.weekTo.split("-")[1]) {
          if (this.weekFrom.split("-")[0] > this.weekTo.split("-")[0]) {
            this.$refs.weekEndAtSelector.clearWeek();
          }
        } else if (this.weekFrom.split("-")[1] > this.weekTo.split("-")[1]) {
          this.$refs.weekEndAtSelector.clearWeek();
        }
      }
    },
    currentUser() {
      if (!this.securePaymentStages[0]) {
        this.getSecurePaymentLapseList();
      }
    },
  },
  methods: {
    clearFilters() {
      this.cleaning = true;
      this.weekFrom = null;
      this.weekTo = null;
      this.$refs.weekStartAtSelector.clearWeek();
      this.$refs.weekEndAtSelector.clearWeek();
      this.filters = {};
      (this.states = filterGroup[this.filterType][0].value),
        this.$emit("search"),
        (this.cleaning = false);
      this.expanded = false;
    },
    inputChanged(value) {
      if (!this.cleaning) {
        this.$emit("search");
      }
      if (value === "apply") this.expanded = false;
    },
    minWeek() {
      if (this.weekFrom) {
        return this.weekFrom;
      }
    },
    toggleFilters() {
      this.expanded = !this.expanded;
    },
    getSecurePaymentLapseList() {
      if (this.loadingSelectableAtt && this.currentUser) {
        return;
      }
      this.loadingSelectableAtt = true;
      axios
        .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
          params: {
            query: print(SelectableAttributes),
            variables: {
              object: "marketplace/secure_payment",
              attribute: "stage",
            },
          },
        })
        .then((res) => {
          if (!res.data.errors) {
            if (res.data.data.retrieveSelectableAttributes.success) {
              this.securePaymentStages =
                res.data.data.retrieveSelectableAttributes.selectableAttributes;
            }
          }
          this.loadingSelectableAtt = false;
        });
    },
    getBusinessList() {
      if (this.loadingRetrieveParent && this.currentUser) {
        return;
      }
      this.loadingRetrieveParent = true;
      axios
        .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
          params: {
            query: print(retrieveParentAttributes),
            variables: {
              object: "marketplace/offer",
              parentObject: "organization",
              parentAttribute: "business_name",
              attribute: "organization_id",
            },
          },
        })
        .then((res) => {
          if (!res.data.errors) {
            if (res.data.data.retrieveParentAttributes.success) {
              this.organizationList =
                res.data.data.retrieveParentAttributes.parentAttributes;
            }
          }
          this.loadingRetrieveParent = false;
        });
    },
    getEstablishmentsList() {
      if (this.loadingRetrieveFamily && this.currentUser) {
        return;
      }
      this.loadingRetrieveFamily = true;
      axios
        .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
          params: {
            query: print(retrieveFamilyAttributes),
            variables: {
              currentUserToken: localStorage.getItem("USER_TOKEN"),
              familyAttributes: {
                // ESTO LO HICE PARA QUE NO SE ME TRABE MIENTRAS PROBABA. QUITAR ESTE CAMBIO
                object: "marketplace/offer",
                parents: [
                  {
                    object: "part",
                    parents: [
                      {
                        object: "destination",
                        attributes: ["id", "name", "organization_id"],
                      },
                      {
                        object: "origin",
                        attributes: ["id", "name", "organization_id"],
                      },
                    ],
                  },
                ],
              },
            },
          },
        })
        .then((res) => {
          if (!res.data.errors) {
            this.establishmentsList = res.data.data.retrieveFamilyAttributes;
          }
          this.loadingRetrieveFamily = false;
        });
    },
    scrollHandler(event) {
      let filters = document.querySelector(".aside-filters.static");
      if (filters !== null) {
        if (
          filters.getBoundingClientRect().bottom - 768 + window.innerHeight <
          400
        ) {
          filters.classList.add("fixed-top");
        } else {
          filters.classList.remove("fixed-top");
        }
      }
    },
  },
};
</script>
<style scoped>
  .top-margin {
    margin-top: 10px;
  }
  .transition {

    animation: go_in 1s;
    
  }

  @keyframes go_in
  {
     0% {opacity:0;}
     100% {opacity:1;}
  }

</style>